class AddToCartButton extends HTMLElement {
  constructor() {
    super();
    this.state = {
      text: '',
      disabled: false,
      froze: false,
    };

    this.defaultText = '';
    this.selectors = {
      button: '.product-form__submit-button',
      buttonText: '.product-form__submit-button .shared-button__leading-label',
    };

    this.savedState = null;
  }

  connectedCallback() {
    if (!this.submitButton) return;

    this.state.text = this.submitButtonText.textContent;
    this.setDefaultTextValue();
    this.state.disabled = this.submitButton.hasAttribute('disabled');
    this.saveCurrentState();
    // Set default state since size shouldn't be selected on load
    this.resetSubmitButton();

    subscribe(PUB_SUB_EVENTS.submitButtonChange, (event) => {
      this.setState(event);
    });
  }

  render() {
    if (this.submitButtonText) {
      this.submitButtonText.textContent = this.state.text;
      this.submitButton.disabled = this.state.disabled;
    }
  }

  setState({ text, disabled, ariaLabel, setDefaultText = false, froze = false, remember = false } = {}) {
    if (this.state.froze) {
      return;
    }

    if (ariaLabel) {
      this.submitButton.setAttribute('aria-label', ariaLabel);
    }

    if (remember) {
      this.saveCurrentState();
    }

    this.state.text = text;
    if (setDefaultText) this.state.text = this.defaultText;
    this.state.disabled = !!disabled;
    this.state.froze = froze;
    this.render();
  }

  /**
   * Resets button to the enabled state.
   */
  resetSubmitButton() {
    this.submitButton.removeAttribute('disabled');
    this.submitButtonText.textContent = this.defaultText;
  }

  saveCurrentState() {
    this.savedState = { ...this.state };
  }

  calculatePrice() {
    if (this.currentPrice) {
      if (this.isCompleteWithChecked) {
        const completeWithPrice = document
          .querySelector('[data-replaceable-complete-with-card] #main-price')
          ?.getAttribute('data-product-price');
        const currency = Shopify.currency.active;

        const total = window.utilities.parsePrice(this.currentPrice) + window.utilities.parsePrice(completeWithPrice);
        return ` - ${window.utilities.formatPrice(currency, total)}`;
      }

      return ` - ${this.currentPrice}`;
    }

    return '';
  }

  setDefaultTextValue() {
    if (this.state.froze) {
      return;
    }
    const defaultText = this.isCompleteWithChecked
      ? window.variantStrings.addToCartCompleteWith
      : window.variantStrings.addToCart;

    const atcLabel = `${defaultText}${this.calculatePrice()}`;
    this.defaultText = atcLabel;

    if (!this.state.disabled) {
      this.state.text = atcLabel;
      const defaultAria = this.submitButton.getAttribute('data-default-aria-label');
      this.submitButton.setAttribute('aria-label', defaultAria);
    }

    this.render({ setDefaultText: true });
  }

  restoreLastSavedState() {
    if (this.savedState) {
      this.state = { ...this.savedState };
      this.savedState = null;
      this.render();
    }
  }

  unfreeze() {
    if (this.state.froze) {
      this.state.froze = false;
    }
  }

  enable() {
    if (this.state.disabled) {
      this.state.disabled = false;
    }
  }

  get submitButton() {
    return this.querySelector(this.selectors.button);
  }

  get submitButtonText() {
    return this.querySelector(this.selectors.buttonText);
  }

  get currentPrice() {
    return document.getElementById('main-price')?.getAttribute('data-product-price');
  }

  get isCompleteWithChecked() {
    return document.querySelector('[data-replaceable-complete-with-card] input[type="checkbox"]')?.checked;
  }
}

customElements.define('add-to-cart-button', AddToCartButton);
